export const CLIENT_ID: string = import.meta.env.VITE_CLIENT_ID;

export const AUTH_URL: string = import.meta.env.VITE_AUTH_URL;

export const ACCESS_TOKEN_URL: string = import.meta.env.VITE_ACCESS_TOKEN_URL;

export const OAUTH_USER_INFO_URL: string = import.meta.env
  .VITE_OAUTH_USER_INFO_URL;
